import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-padding" }
const _hoisted_2 = { class: "d-none d-md-flex" }
const _hoisted_3 = { class: "full-width" }
const _hoisted_4 = { class: "d-flex flex-column d-md-none" }
const _hoisted_5 = { class: "text-just" }

import LogoImageBackground from "@/components/LogoImageBackground.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AffiliationsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('sectionAffiliations.professionalAffiliations')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff1')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff2')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff3')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff4')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff1')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff2')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff3')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionAffiliations.profAff4')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})